export class Constant {
  public static base_url = 'https://surety-api.beta-techs.com/';
  public static new_base_url = 'https://surety-api.beta-techs.com/';
  //public static base_url = 'http://localhost:50415/';
  //public static new_base_url = 'http://localhost:50415/';
}